"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchPickupPoints = void 0;
var _fetching = require("@ori/fetching");
var _tsUtils = require("@ori/ts-utils");
var _useGeocodingSearch = require("../hooks/useGeocodingSearch");
var _logger = require("../logger");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
// istanbul ignore file -- api
const localLogger = _logger.mainLogger.createChild('fetchPickupPoints');
const fetchPickupPoints = async (param)=>{
    let { headers, graphQlNetUrl, params: { searchTerm, ...params }, credentials, mapProvider, language, formattedToken, tenant } = param;
    try {
        var _detailData_shopping_shoppingSession_deliveryChannels, _detailData_shopping_shoppingSession, _detailData_shopping, _detailData_shopping_shoppingSession1, _detailData_shopping1;
        let detailData = await (0, _fetching.fetchGraphql)({
            query: _queriesNet.deliveryChannelsQuery,
            url: graphQlNetUrl,
            headers,
            variables: {
                ...params,
                searchTerm
            }
        });
        var _detailData_shopping_shoppingSession_deliveryChannels_totalRecords;
        const hasResults = ((_detailData_shopping_shoppingSession_deliveryChannels_totalRecords = (_detailData_shopping = detailData.shopping) === null || _detailData_shopping === void 0 ? void 0 : (_detailData_shopping_shoppingSession = _detailData_shopping.shoppingSession) === null || _detailData_shopping_shoppingSession === void 0 ? void 0 : (_detailData_shopping_shoppingSession_deliveryChannels = _detailData_shopping_shoppingSession.deliveryChannels) === null || _detailData_shopping_shoppingSession_deliveryChannels === void 0 ? void 0 : _detailData_shopping_shoppingSession_deliveryChannels.totalRecords) !== null && _detailData_shopping_shoppingSession_deliveryChannels_totalRecords !== void 0 ? _detailData_shopping_shoppingSession_deliveryChannels_totalRecords : 0) === 0;
        // Temporary workaround for geocoding search fallback (let's see how temporary it will be)
        if (searchTerm && hasResults) {
            const geocodingLocation = await (0, _useGeocodingSearch.getGeocodingSearchResult)({
                provider: mapProvider,
                credentials,
                searchTerm,
                currentLanguage: language,
                formattedToken,
                tenant
            });
            if (!geocodingLocation) {
                return {
                    pickupPoints: [],
                    totalRecords: 0
                };
            }
            // Search again with geocoding location
            detailData = await (0, _fetching.fetchGraphql)({
                query: _queriesNet.deliveryChannelsQuery,
                url: graphQlNetUrl,
                headers,
                variables: {
                    ...params,
                    latitude: geocodingLocation.latitude,
                    longitude: geocodingLocation.longitude
                }
            });
        }
        var _detailData_shopping_shoppingSession_deliveryChannels1;
        const { totalRecords = 0, collection = [] } = (_detailData_shopping_shoppingSession_deliveryChannels1 = (_detailData_shopping1 = detailData.shopping) === null || _detailData_shopping1 === void 0 ? void 0 : (_detailData_shopping_shoppingSession1 = _detailData_shopping1.shoppingSession) === null || _detailData_shopping_shoppingSession1 === void 0 ? void 0 : _detailData_shopping_shoppingSession1.deliveryChannels) !== null && _detailData_shopping_shoppingSession_deliveryChannels1 !== void 0 ? _detailData_shopping_shoppingSession_deliveryChannels1 : {};
        var _collection_filter_map;
        const pickupPoints = (_collection_filter_map = collection === null || collection === void 0 ? void 0 : collection.filter(_tsUtils.isNonNullable).map(_utils.mapPickupPoint)) !== null && _collection_filter_map !== void 0 ? _collection_filter_map : [];
        return {
            pickupPoints,
            totalRecords
        };
    } catch (error) {
        localLogger.error(new Error('fetchGraphql', {
            cause: error
        }));
        throw error;
    }
};
exports.fetchPickupPoints = fetchPickupPoints;
